import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid, getCacheKey } from '../cacheUtils';

export const fetchDashboardMetrics = createAsyncThunk(
  'dashboard/fetchMetrics',
  async (filters = {}, { getState, rejectWithValue }) => {
    const state = getState().dashboard;
    const cacheKey = getCacheKey(filters);

    if (isCacheValid(state.lastFetched[cacheKey])) {
      return { data: state.data[cacheKey], cacheKey, cached: true };
    }

    try {
      const params = new URLSearchParams();
      if (filters.plan) params.append('plan', filters.plan);
      if (filters.status) params.append('status', filters.status);
      const queryString = params.toString();
      const url = `/api/dashboard/overview${queryString ? `?${queryString}` : ''}`;

      const response = await Axios.get(url);
      return { data: response.data.data, cacheKey, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch dashboard metrics');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: {},
    loading: false,
    error: null,
    lastFetched: {},
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardMetrics.pending, (state, action) => {
        const cacheKey = getCacheKey(action.meta.arg);
        if (!state.data[cacheKey]) {
          state.loading = true;
        }
      })
      .addCase(fetchDashboardMetrics.fulfilled, (state, action) => {
        const { data, cacheKey, cached } = action.payload;
        if (!cached) {
          state.data[cacheKey] = data;
          state.lastFetched[cacheKey] = Date.now();
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDashboardMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateDashboardCache } = dashboardSlice.actions;
export default dashboardSlice.reducer;